<template>

    <div class="container">

        <app-head title="Options" />

        <div class="d-flex justify-content-start align-items-center mb-3 gap-3">
            <h1 class="">{{ __('Grundeinstellungen') }}</h1>
            <div class="">
            </div>
        </div>

        <form @submit.prevent="form.post(route('admin.system-options.submit'))">

            <div class="row row-cols-1 g-4 mb-4">

                <div class="col">
                    <div class="card">
                        <div class="card-body">
                            <fieldset>
                                <legend>{{ __('AGB') }}</legend>

                                <!--<text-input label="repeater" v-model="form.repeater[0]" :error="form.errors.repeater" />-->
                                <!--<text-input label="repeater" v-model="form.repeater[1]" :error="form.errors.repeater" />-->

                                <checkbox-input label="supplier_must_accept_terms" v-model="form.supplier_must_accept_terms" :error="form.errors.supplier_must_accept_terms" />
                                <text-input label="supplier_terms_title" v-model="form.supplier_terms_title" :error="form.errors.supplier_terms_title" />
                                <editor-input label="supplier_terms_content" v-model="form.supplier_terms_content" :error="form.errors.supplier_terms_content" />

                                <checkbox-input label="customer_must_accept_terms" v-model="form.customer_must_accept_terms" :error="form.errors.customer_must_accept_terms" />
                                <text-input label="customer_terms_title" v-model="form.customer_terms_title" :error="form.errors.customer_terms_title" />
                                <editor-input label="customer_terms_content" v-model="form.customer_terms_content" :error="form.errors.customer_terms_content" />

                                <!--                            <select-input label="account" v-model="form.account_id" v-if="accounts">
                                                                <option :value="account.id" v-for="account in accounts">{{ account.name }}</option>
                                                            </select-input>-->
                                <!--<text-input label="email" type="email" v-model="form.email" :error="form.errors.email" />-->
                                <!--<checkbox-input label="enabled" v-model="form.enabled" :error="form.errors.enabled" />-->
                                <!--<textarea-input label="description" v-model="form.description" :error="form.errors.description" />-->
                                <!--<percent-input label="tax_rate" v-model="form.tax_rate" :error="form.errors.tax_rate" v-if="form.tax_calc_mode === 'value'" />-->
                                <!--<price-input label="lower_bound" v-model="option.lower_bound" :error="form.errors[`options.${optionIndex}.lower_bound`]" />-->        
                            </fieldset>
                        </div>
                    </div>
                </div>

                <div class="col">
                    <div class="card">
                        <div class="card-body">
                            <fieldset>
                                <legend>{{ __('Kontakt') }}</legend>
                                <text-input type="tel" label="contact_phone" v-model="form.contact_phone" :error="form.errors.contact_phone" />
                                <text-input type="url" label="contact_url" v-model="form.contact_url" :error="form.errors.contact_url" />
                                <text-input type="email" label="contact_email" v-model="form.contact_email" :error="form.errors.contact_email" />
                                <textarea-input label="contact_address" v-model="form.contact_address" :error="form.errors.contact_address" />
                                <textarea-input 
                                    label="mail_signature" 
                                    rows="20" 
                                    v-model="form.mail_signature" 
                                    :error="form.errors.mail_signature"
                                    :help="__('Markdown syntax. To create a line break or new line (<br>), end a line with two or more spaces, and then type return.')"
                                    />
                            </fieldset>
                        </div>
                    </div>
                </div>

                <div class="col">
                    <div class="card">
                        <div class="card-body">
                            <fieldset>
                                <legend>{{ __('Misc') }}</legend>
                                <editor-input label="welcome_content" v-model="form.welcome_content" :error="form.errors.welcome_content" />
                            </fieldset>
                        </div>
                    </div>
                </div>

                <div class="col">
                    <div class="card">
                        <div class="card-body">
                            <fieldset>
                                <legend>{{ __('Scripts') }}</legend>

                                <textarea-input label="head_content" rows="10" v-model="form.head_content" :error="form.errors.head_content" />
                                <textarea-input label="footer_content" rows="10" v-model="form.footer_content" :error="form.errors.footer_content" />

                            </fieldset>
                        </div>
                    </div>
                </div>

            </div>

            <div class="d-flex align-items-center w-100">
                <submit-button :form="form" />
            </div>

        </form>



        <!--        <div class="row row-cols-2 row-cols-3 row-cols-4 g-4">
                    <div class="col" v-for="menuItem in menuItems">
                        <div class="card shadow-sm h-100">
                            <div class="card-body">
                                <div class="fs-2 text-primary">
                                    <i :class="menuItem.icon"></i>
                                </div>
                                <h3 class="card-title">
                                    {{ menuItem.label }}
                                </h3>
                                <inertia-link :href="menuItem.url" class="stretched-link">
                                    {{ __('Bearbeiten') }}
                                </inertia-link>
                            </div>
                        </div>
                    </div>
                </div>-->

    </div>

</template>

<script>
    import TextInput from '@/shared/Inputs/TextInput';
    import PriceInput from '@/shared/Inputs/PriceInput';
    import EditorInput from '@/shared/Inputs/EditorInput';
    import PercentInput from '@/shared/Inputs/PercentInput';
    import SelectInput from '@/shared/Inputs/SelectInput';
    import TextareaInput from '@/shared/Inputs/TextareaInput';
    import CheckboxInput from '@/shared/Inputs/CheckboxInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';

    export default {
        props: [
            'systemOptions',
        ],
        data() {
            return {
                form: this.$inertia.form({
//                    repeater: this.systemOptions.repeater,

                    contact_phone: this.systemOptions.contact_phone,
                    contact_email: this.systemOptions.contact_email,
                    contact_url: this.systemOptions.contact_url,
                    contact_address: this.systemOptions.contact_address,

                    supplier_must_accept_terms: this.systemOptions.supplier_must_accept_terms,
                    supplier_terms_title: this.systemOptions.supplier_terms_title,
                    supplier_terms_content: this.systemOptions.supplier_terms_content,

                    customer_must_accept_terms: this.systemOptions.customer_must_accept_terms,
                    customer_terms_title: this.systemOptions.customer_terms_title,
                    customer_terms_content: this.systemOptions.customer_terms_content,

                    welcome_content: this.systemOptions.welcome_content,

                    contact_email: this.systemOptions.contact_email,
                    mail_signature: this.systemOptions.mail_signature,

                    head_content: this.systemOptions.head_content,
                    footer_content: this.systemOptions.footer_content,
                }),
//                menuItems: [
//                    {label: this.__('Grundeinstellungen'), url: this.route('admin.system-options.index'), icon: 'bi bi-envelope'},
//                    {label: this.__('E-Mails'), url: this.route('admin.system-options.index'), icon: 'bi bi-envelope'},
//                    {label: this.__('Lieferdienste'), url: this.route('admin.system-options.index'), icon: 'bi bi-envelope'},
//                    {label: this.__('Zahlungsmethoden'), url: this.route('admin.system-options.index'), icon: 'bi bi-envelope'},
//                    {label: this.__('Administratoren'), url: this.route('admin.system-options.index'), icon: 'bi bi-envelope'},
//                    {label: this.__('E-Mails'), url: this.route('admin.system-options.index'), icon: 'bi bi-envelope'},
//                ],
            }
        },
        components: {
            TextInput,
            PriceInput,
            EditorInput,
            PercentInput,
            SelectInput,
            TextareaInput,
            CheckboxInput,
            SubmitButton,
        },
    }
</script>

